/*
 * Container for one or more filter rows
 */
import React from 'react'
const FiltersContainer = ({ children }) => {
  return (
    <div className='filters-container'>
      {children}
    </div>
  )
}

export default FiltersContainer
